<template>
  <div class="d-flex pa-0 ma-0 my-2 align-center">
    <v-card color="transparent" flat tile>
      <video
        v-if="allowvideo && message.url !== null"
        @error="allowvideo = !allowvideo"
        width="180"
        controls
        :src="message.url"
      >
        Your browser does not support the video tag.
      </video>
      <div v-else>
        <img
          src="https://developers.google.com/maps/documentation/maps-static/images/error-image-generic.png?hl=es-419"
          width="150px"
        />
        <br />
        <p class="font-italic mb-1">* Content Expire</p>
      </div>
    </v-card>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn small icon v-bind="attrs" :disabled="!Editing" v-on="on">
          <v-icon>more_vert</v-icon>
        </v-btn>
      </template>
      <v-card max-width="300" :height="QuestionList.length > 1 ? 200 : undefined">
        <v-list>
          <v-list-item @click="editvideo = true">
            <v-list-item-title>แก้ไข</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$delete(QuestionList, index)">
            <v-list-item-title>ลบ</v-list-item-title>
          </v-list-item>
          <div v-if="QuestionList.length > 1">
            <v-divider></v-divider>
            <v-subheader>สลับคำถาม</v-subheader>
            <v-list-item
              v-for="(item, i) in QuestionList.filter(
                (t) => t.type !== 'quickReply'
              )"
              @click="movequestion(i)"
              :key="i"
            >
              <v-list-item-title>{{
                item.type === "image"
                  ? `รูปภาพที่ ${i + 1}`
                  : item.type === "video"
                  ? `วิดีโอที่ ${i + 1}`
                  : item.text
              }}</v-list-item-title>
            </v-list-item>
          </div>
        </v-list>
      </v-card>
    </v-menu>
    <EditVideo
      :visible="editvideo"
      :message="message"
      @close="editvideo = false"
    />
  </div>
</template>
<script>
import EditVideo from "./EditVideo.vue";
export default {
  props: ["message", "conversation", "index", "Editing", "QuestionList"],
  components: { EditVideo },
  data() {
    return {
      slide: false,
      allowvideo: true,
      url: "",
      editvideo: null,
    };
  },
  methods: {
    movequestion(indexmove) {
      let index = this.index;
      let moveindex = indexmove;
      let old_index = index;
      let new_index = moveindex;
      if (new_index >= this.QuestionList.length) {
        var k = new_index - this.QuestionList.length + 1;
        while (k--) {
          this.QuestionList.push(undefined);
        }
      }
      this.QuestionList.splice(
        new_index,
        0,
        this.QuestionList.splice(old_index, 1)[0]
      );
    },
  },
};
</script>
